module.exports = __webpack_public_path__ + "img/litva.cde095ed.svg";